import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { setCookie } from "../../../utils/validators";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import Viewer from "@toast-ui/editor/dist/toastui-editor-viewer";
import { useId } from "react-id-generator";
import download_file from "../../../images/download_file.png";
import { API_HOST } from "../../../utils/Constants";

const NoticePop = ({ boardId }) => {
  const SERARCH_BOARDINFO_URL = "/common/board/searchBoardInfo.do";
  const SEARCH_BOARD_FILELIST_URL = "/common/board/searchBoardFileList.do";

  const [primaryParameters, setPrimaryParameters] = useState({
    boardId: boardId,
  });
  const [viewerId] = useId(1, "viewer-");
  var viewer;
  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_BOARDINFO_URL,
    },
    { manual: true }
  );

  const initItem = {
    boardTitle: "",
    boardContent: "",
    regNm: "",
    regDt: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);
  const [fileList, setFileList] = useState([]);
  const [show, setShow] = useState(true);
  const searchBoardInfo = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_BOARDINFO_URL,
      params: primaryParameters,
    });

    setFieldValues(data[0]);
    //console.log(data[0]);
    viewer.setMarkdown(data[0].boardContent);

    const response = await fetchData({
      url: SEARCH_BOARD_FILELIST_URL,
      params: {
        boardId: boardId,
      },
    });

    //console.log(response.data.data);
    var fList = [];
    response.data.data.forEach((file) => {
      var fileProp = {
        uid: file.fileId,
        name: file.orgFileNm,
        status: "done",
        url: API_HOST + file.url,
      };
      fList.push(fileProp);
    });

    setFileList(fList);
  };
  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    viewer = new Viewer({
      el: document.querySelector("#" + viewerId),
      height: "100%",
      initialValue: fieldValues?.boardContent,
    });
    if (boardId !== "") {
      searchBoardInfo();
    }
  }, []);

  const handleOk = (returnData) => {
    setShow(false);
  };

  const handleClose = (returnData) => {
    setShow(false);
  };

  const onPopUpNotShot = () => {
    setCookie(boardId, "end", 7);
    setShow(false);
  };

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>공지사항</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="databox">
            <ul className="t_form board">
              <li>
                <div className="title">
                  <span className="red">*</span>게시판 제목
                </div>
                <div className="formbox">{fieldValues.boardTitle}</div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>등록일
                </div>
                <div className="ip_textandbutton">
                  <div>{fieldValues.regDt}</div>
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>작성자
                </div>
                <div className="formbox">{fieldValues.regNm}</div>
              </li>
              {fileList.length > 0 ? (
                <li style={{ height: "100%" }}>
                  <div className="formfile">
                    <strong>첨부파일</strong>{" "}
                    <span className="filecount">
                      ({fileList && fileList.length}개)
                    </span>
                    <div>
                      {fileList &&
                        fileList.map((file, index) => (
                          <div>
                            <a href={file.url} target="_blank" key={index}>
                              <img src={download_file} />
                            </a>
                            {file.name}
                            <span key={index}></span>
                          </div>
                        ))}
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
              <li style={{ height: "400px", overflowY: "auto" }}>
                <div className="formbox" style={{ height: "400px" }}>
                  <div id={viewerId}></div>
                </div>
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onPopUpNotShot}>
            7일동안 보지 않기
          </Button>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalNoticePop = createModal(NoticePop);

export default NoticePop;
